import { render, staticRenderFns } from "./base-table.vue?vue&type=template&id=7d86066e&scoped=true&"
import script from "./base-table.vue?vue&type=script&lang=js&"
export * from "./base-table.vue?vue&type=script&lang=js&"
import style0 from "./base-table.vue?vue&type=style&index=0&id=7d86066e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d86066e",
  null
  
)

export default component.exports